import {
  updateTriggerOrMatchStatus,
  updateAmbientScreeningSubmissionStatus,
} from "./duplicateSubmissions";
import { showErrorToast } from "./helpers";

export const handleSetTriggerOrMatchStatus = async (
  matchId,
  persistentId,
  status,
  additionalParams = {},
  showLoader = null,
  hideLoader = null
) => {
  try {
    if (showLoader) showLoader();
    await updateTriggerOrMatchStatus(matchId, persistentId, status, additionalParams);
  } catch (err) {
    showErrorToast('Error updating status');
    throw err;
  } finally {
    if (hideLoader) hideLoader();
  }
};

export const handleSetSubmissionStatus = async (
  recordId,
  status,
  additionalParams = {},
  showLoader = null,
  hideLoader = null
) => {
  try {
    if (showLoader) showLoader();
    const result = await updateAmbientScreeningSubmissionStatus(recordId, status, additionalParams);
    return result;
  } catch (err) {
    showErrorToast('Error updating submission status');
    throw err;
  } finally {
    if (hideLoader) hideLoader();
  }
};
